module.exports = __webpack_public_path__ + "static/img/user_story_avatar1.6e21720c.png";